import React, { useState } from 'react'
import './FaultSecondPageCustom_bus.css';
import { useEffect, useMemo } from 'react';
import "../FaultFirstPage_Bus/Horizantal_bus.css"
import * as $ from 'jquery';

import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import NoData from '../../../Dashboard/Driveanalysis/NoData';
import WaterMark from '../../../Dashboard/DashboardMain/WaterMark';
import { keyboard } from '@testing-library/user-event/dist/keyboard';

export default function FaultSecondPageDataBars_Bus(props) {
    const [faultCount, setFaultCount] = useState(0);
    const [alarmCount, setAlarmCount] = useState(0);
    const [DTCCount, setDTCCount] = useState(0);
    const [faultCountDsnt, setFaultCountDsnt] = useState(0);
    const [alarmCountDsnt, setAlarmCountDsnt] = useState(0);
    const [DTCCountDsnt, setDTCCountDsnt] = useState(0);
    const [timeDuration, setTimeDuration] = useState(0);
    const [chasisDetails, setChasisDetails] = useState([]);
    const resFaultCntDsnt = (data) => {
        setFaultCount(data.Alarm_count.value)
        setFaultCountDsnt(data.UniqueSignal.value)
    };
    const resAlarmCntDsnt = (data) => {
        setAlarmCount(data.Alarm_count.value);
        setAlarmCountDsnt(data.UniqueSignal.value)
    };
    const resDTCCntDsnt = (data) => {
        setDTCCount(data[0].imbalance_vehicle.value)
        setDTCCountDsnt(data.imbalance_vehicle.value)
    };
    const resTimeDuration = (data) => {
        setTimeDuration(data[0].duration.value)
    };
    const resChasisDetails = (data) => {
        if (data.length > 0) {
            setChasisDetails(data[0]._source)
        } else {
            setChasisDetails({
                "vehicle_registration_number": "",
                "DLR_ORG_CITY": "",
                "vehicleId": "",
                "Depot_Name": "",
                "PL": "",
                "PPL": "",
                "LOB": ""
            })
        }
    };
    useEffect(() => {
        let body = { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO }
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countCurrentImbalance', body: body }, resDTCCntDsnt);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countFaultActiveDuration', body: body }, resTimeDuration);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/global_filter', body: body }, resChasisDetails);
        fetchData({ url: API_URL_MAIN + 'faultSecondpage_bus/countUniqueAlarm', body: body }, resAlarmCntDsnt);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countDistinctDTC_bus', body: body }, resFaultCntDsnt);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/countCurrentImbalance', body: body }, resDTCCntDsnt);
    }, [props])

    function toTime(minutes) {
        var h = Math.floor(minutes / 3600);
        var m = minutes % 60;
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        return `${h}h ${m}min`
    }
    const [counterSignal, setCounterSignal] = useState(0);
    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [falutBar, setFaultBar] = useState([]);
    const [falutBarNew, setFaultBarNew] = useState([]);
    const [falutBarUFA, setFaultBarUFA] = useState([]);
    const [falutBarUAA, setFaultBarUAA] = useState([]);
    const [falutBarUDA, setFaultBarUDA] = useState([]);
    const [falutBarUDA_2, setFaultBarUDA_2] = useState([]);
    const [UFAPercent, setUFAPercent] = useState([]);
    const [faultAnaPercent, setFaultAnaPercent] = useState([]);
    const [faultAnaPercent_occ, setFaultAnaPercent_occ] = useState([]);


    const [UAAPercent, setUAAPercent] = useState([]);
    const [UDAPercent, setUDAPercent] = useState([]);
    const [faultPercent, setFaultPercent] = useState([]);
    const [faultNewPercent, setFaultNewPercent] = useState([]);
    const [faultSelected, setFaultSelected] = useState('duration')//occurrence
    const [fault_Selected, setFault_Selected] = useState('occurance')
    const [tableTitle, setTableTitle] = useState("Distinct Signals");//Occurrence
    const [tableTitle_Imb, setTableTitle_Imb] = useState("Duration");//Occurrence

    const changeFault_Imbalance = (selectOp) => {
        setFault_Selected(selectOp);
        if (selectOp == "occurrence") {
            setTableTitle_Imb("Occurrence")
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_currentImbalance_occurance', body: { selected: 'occurrence', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceDataUDA);
        } else {
            setTableTitle_Imb("Duration")
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_currentImbalance_duration', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceDataUFA);
        }
    }

    const changeFault = (selectOp) => {
        setFaultSelected(selectOp);
        if (selectOp == "occurrence") {
            setTableTitle("Occurrence")
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_FaultAnalysis', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceData);
        } else {
            setTableTitle("Distinct Signals")
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_FaultAnalysis', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responseDataFaultAnalysis);

            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_currentImbalance_duration', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceDataUFA);
        }
    }

    function addECU(dataArr, chngKey) {
        const mainECU = ["BCS-1", "BCS-2", "Aux-1", "Aux-2", "BMS", "MCU", "HVAC", "VCU"];
        mainECU.forEach(element => {
            var index = dataArr.findIndex(x => x.key.ECU == element);
            index === -1 && dataArr.push({
                "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
            })
        });
        let dataA = dataArr.sort(function (a, b) {
            return a.key.ECU.localeCompare(b.key.ECU);
        });
        return dataA;
    }
    function addECUPercent(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.UniqueSignal.value; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.UniqueSignal.value / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }

    // Current Imbalance for percentage width
    function addCurrentImbalancePercent(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.imbalance_count; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.imbalance_count / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }
    function addECUPercentFault(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) { return o.occurance.value; }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.occurance.value / max_value) * 100);
            percentArr.push(isNaN(percent) ? 0 : percent);
        })

        return percentArr
    }
    function addECUPercentFaultNew(arr) {
        const max_value = Math.max.apply(Math, arr.map(function (o) {
            return o.rating;
        }));
        let percentArr = [];
        arr.map((val, i) => {
            var percent = Math.ceil((val.rating / max_value) * 100);

            percentArr.push(isNaN(percent) ? 0 : percent);
        })
        return percentArr
    }


    // Function Fault Analysis Occurance
    const responceData = (data) => {
        const ecu = addECU(data, "occurance");
        setFaultAnaPercent_occ(addECUPercentFault(ecu))
        setFaultBar(ecu)
    }

    const responseDataFaultAnalysis = (data) => {
        const ecu = addECU(data, "UniqueSignal");
        setFaultAnaPercent(addECUPercent(ecu))
        setFaultBarUFA(ecu);
    }

    // Current Imbalance Distinct Selector
    const responceDataUFA = (data) => {
        const result = [];

        for (const key in data[0]) {
            if (key !== "doc_count") {
                result.push({
                    imbalance_key: key.toUpperCase().replace('_', ' '),
                    imbalance_count: data[0][key].value.toFixed(0)
                });
            }
        }

        result.sort((a, b) => a.imbalance_key.localeCompare(b.imbalance_key));

        setUFAPercent(addCurrentImbalancePercent(result));
        setFaultBarUDA_2(result)
    }
    const responceDataUAA = (data) => {
        const ecu = addECU(data, "UniqueSignal");
        setUAAPercent(addECUPercent(ecu));
        setFaultBarUAA(ecu);
    }

    // Current Imbalance of Occurance Selector
    const responceDataUDA = (data) => {
        // Map and transform the input object
        const result = [];
        for (const key in data[0]) {
            if (key !== "doc_count") {
                result.push({
                    imbalance_key: key.toUpperCase().replace('_', ' '),
                    imbalance_count: data[0][key].value
                });
            }
        }

        result.sort((a, b) => a.imbalance_key.localeCompare(b.imbalance_key));
        setUDAPercent(addCurrentImbalancePercent(result));
        let counter = 0;
        for (let i = 0; i < result.length; i++) {
            if (result[i].imbalance_count !== 0) {
                counter = counter + 1;
            }
        }
        setCounterSignal(counter)
        setFaultBarUDA(result);
    }
    const responseDataImbalance = (data) => {

    }
    const responceDataNew = (datacal) => {
        let data = []
        let data1 = []

        data1.push({ "key": { "ECU": "Aux2" }, "duration": { "value": datacal[0].Aux2.value } })
        data1.push({ "key": { "ECU": "BCS1" }, "duration": { "value": datacal[0].BCS1.value } })
        data1.push({ "key": { "ECU": "BCS2" }, "duration": { "value": datacal[0].BCS2.value } })
        data1.push({ "key": { "ECU": "BMS" }, "duration": { "value": datacal[0].BMS.value } })
        data1.push({ "key": { "ECU": "HVAC" }, "duration": { "value": datacal[0].HVAC.value } })
        data1.push({ "key": { "ECU": "MCU" }, "duration": { "value": datacal[0].MCU.value } })
        data1.push({ "key": { "ECU": "VCU" }, "duration": { "value": datacal[0].VCU.value } })
        data1.push({ "key": { "ECU": "Aux1" }, "duration": { "value": datacal[0].Aux1.value } })

        Object.keys(datacal[0]).forEach((key, value) =>
            console.log("logs", key)
        )
        let val
        for (let i = 0; i < data1.length; i++) {
            if (data1[i].key.ECU === "BMS") {
                val = (data1[i].duration.value) / 60
                data.push({ "key": data1[i].key, "duration": { "value": parseFloat(val.toFixed(2)) } })
            } else {
                val = (data1[i].duration.value * 25) / 60
                data.push({ "key": data1[i].key, "duration": { "value": parseFloat(val.toFixed(2)) } })
            }

        }


        const objArray = [];
        Object.keys(data).forEach(key => objArray.push({
            name: data[key].key.ECU,
            rating: data[key].duration.value
        }))

        const objArrayA = objArray.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
        setFaultBarNew(objArrayA);
        setFaultNewPercent(addECUPercentFaultNew(objArrayA))
    }

    useEffect(() => {
        let body = { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO }
        if (faultSelected == "occurrence") {
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_FaultAnalysis', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceData);
        } else {
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_FaultAnalysis', body: { startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responseDataFaultAnalysis);
            fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_currentImbalance_duration', body: body }, responceDataUFA);
        }
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_FaultAlarmDuration', body: { selected: 'duration', startDate: props.gloablfilter.startDate, endDate: props.gloablfilter.endDate, vin_num: props.gloablfilter.vin_num, CITY: props.gloablfilter.CITY, DEPO: props.gloablfilter.DEPO } }, responceDataNew);
        // Alarm Distinct Signals
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_AlarmDistincts', body: body }, responceDataUAA);
        fetchData({ url: API_URL_MAIN + 'faultsecondpage_bus/table_currentImbalance_occurance', body: body }, responceDataUDA);
    }, [props])

    function generateBarGraph(wrapper) {
        // Set Up Values Array
        var values = [];

        // Get Values and save to Array
        $(wrapper + ' .bar_bus').each(function (index, el) {
            values.push($(this).data('value'));
        });

        // Get Max Value From Array
        var max_value = Math.max.apply(Math, values);

        // Set width of bar to percent of max value
        $(wrapper + ' .bar_bus').each(function (index, el) {
            var bar = $(this),
                value = bar.data('value'),
                percent = Math.ceil((value / max_value) * 100);

            // Set Width & Add Class
            // bar.width(percent + '%');
            bar.addClass('in');
        });
    }

    useEffect(() => {
        generateBarGraph('#dashboard-stats');
        generateBarGraph('#dashboard-statsUFA');
        generateBarGraph('#dashboard-statsUAA');
        generateBarGraph('#dashboard-statsUDA');
    }, [falutBar, falutBarNew, falutBarUFA, falutBarUAA, falutBarUDA])

    return (
        <>
            <section className="headBG my-2 p-2">
                <div className="row d-flex align-items-center">
                    <div className="col-md-3"><strong>Chassis No:</strong>
                        {chasisDetails.vehicleId}
                    </div>
                    <div className="col-md-1"><strong>City:</strong>
                        {chasisDetails.DLR_ORG_CITY}
                    </div>
                    <div className="col-md-1"><strong>LOB:</strong>
                        {chasisDetails.LOB}
                    </div>
                    <div className="col-md-2"><strong>PPL:</strong>
                        {chasisDetails.PPL}
                    </div>
                    <div className="col-md-2"><strong>PL:</strong>
                        {chasisDetails.PL}
                    </div>
                    <div className="col-md-1"><strong>DEPOT:</strong>
                        {chasisDetails.Depot_Name}
                    </div>
                    <div className="col-md-2"><strong>Reg No.:</strong>
                        {chasisDetails.vehicle_registration_number}
                    </div>
                </div>
            </section>
            <section className="kpi my-3">
                <div className="row equal-cols">
                    <div className="col-md-12 col-sm-12 col-12 col-lg-12">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{counterSignal}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/DTC_count.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0"><b>{DTCCount}</b></p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Current Imbalances Occurrences</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{faultCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/EV-Logo_iconB.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0"><b>{faultCount}</b></p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="float-end" style={{ paddingLeft: "5px", fontSize: "11px" }}>&nbsp;<b></b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/fault_active_duration.png"} /> </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0"><b>{toTime((timeDuration).toFixed(0))}</b></p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Fault Active Time Duration</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-12">
                                <div className="widget_bus p-2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="fst float-end">Distinct signal: <b>{alarmCountDsnt}</b></div>
                                        </div>
                                    </div>
                                    <div className="py-2 d-flex align-items-center">
                                        <div className="widgetIcon"><img src={"../../../assets/img_Bus/alarm_count.png"} />
                                        </div>
                                        <div className="ps-3">
                                            <p className="h5 m-0"><b>{alarmCount}</b></p>
                                            <p className="m-0"><span className="text-muted" style={{ fontSize: "13px !important" }}>Alarm Count</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="row">
                <div className="col-md-3 col-sm-12">
                    <div className="v-title chartbox">
                        <div className="row titlebg_bus1" style={{ marginBottom: "1px" }}>
                            <div className="col-md-12 col-sm-6 col-lg-7">
                                <div className="text-left" style={{ marginTop: "10px" }}>Current Imbalance</div>

                            </div>
                            <div className="col-md-12 col-sm-6 col-lg-5 py-2">
                                <select className="form-select form-select-sm" aria-label="Default select example" onChange={(event) => changeFault_Imbalance(event.target.value)}
                                    value={fault_Selected}>
                                    <option value="duration">Duration</option>
                                    <option value="occurrence">Occurrence</option>
                                </select>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-lg-12 col-md-12 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">Battery Pack</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">{tableTitle_Imb}</p>
                                        </div>
                                    </div>
                                    <div className="chart-wrap_bus">
                                        {/* added code */}
                                        <WaterMark />
                                        <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                                            {
                                                fault_Selected === "occurrence" ?
                                                    falutBarUDA.map((val, i) => {
                                                        if (i < 5) {
                                                            return (
                                                                <div className="row" key={i}>
                                                                    <span className="label" style={{ marginLeft: "-6px" }}>{val.imbalance_key}</span>
                                                                    <div className="bar-wrap_bus">
                                                                        <div className="bar_bus" data-value={val.imbalance_count} style={{ width: UDAPercent[i] + "%" }} />
                                                                    </div>
                                                                    <span className="number">{val.imbalance_count}</span>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                    :
                                                    falutBarUDA_2.map((val, i) => {
                                                        if (i < 5) {
                                                            return (<div className="row" key={i}>
                                                                <span className="label" style={{ marginLeft: "-6px" }}>{val.imbalance_key}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.imbalance_count} style={{ width: UFAPercent[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.imbalance_count}</span>
                                                            </div>
                                                            )
                                                        }
                                                    })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className="v-title chartbox">
                        <div className="row titlebg_bus1" style={{ marginBottom: "1px" }}>
                            <div className="col-md-12 col-sm-6 col-lg-7">
                                <div className="text-left" style={{ marginTop: "10px" }}>Fault Analysis</div>

                            </div>
                            <div className="col-md-12 col-sm-6 col-lg-5 py-2">
                                <select className="form-select form-select-sm" aria-label="Default select example" onChange={(event) => changeFault(event.target.value)}
                                    value={faultSelected}>
                                    <option value="duration">Distinct</option>
                                    <option value="occurrence">Occurrence</option>
                                </select>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">{tableTitle}</p>
                                        </div>
                                    </div>
                                    <div className="chart-wrap_bus">
                                        <WaterMark />
                                        <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                                            {
                                                faultSelected === "occurrence" ?
                                                    falutBar.map((val, i) => {
                                                        if (i <= 3) {
                                                            return (
                                                                <div className="row" key={i}>
                                                                    <span className="label">{val.key.ECU}</span>
                                                                    <div className="bar-wrap_bus">
                                                                        <div className="bar_bus" data-value={val.occurance.value} style={{ width: faultAnaPercent_occ[i] + "%" }} />
                                                                    </div>
                                                                    <span className="number">{val.occurance.value}</span>
                                                                </div>
                                                            )
                                                        }
                                                    })
                                                    :
                                                    falutBarUFA.map((val, i) => {
                                                        if (i <= 3) {
                                                            return (<div className="row" key={i}>
                                                                <span className="label">{val.key.ECU}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.UniqueSignal.value} style={{ width: faultAnaPercent[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.UniqueSignal.value}</span>
                                                            </div>
                                                            )
                                                        }
                                                    })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">{tableTitle}</p>
                                        </div>
                                    </div>
                                    <div className="chart-wrap_bus">

                                        <WaterMark />
                                        <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                                            {
                                                faultSelected === "occurrence" ?
                                                    falutBar.map((val, i) => {
                                                        if (i >= 4) {
                                                            return (<div className="row" key={i - 4}>
                                                                <span className="label">{val.key.ECU}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.occurance.value} style={{ width: faultAnaPercent_occ[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.occurance.value}</span>
                                                            </div>)
                                                        }
                                                    })
                                                    :
                                                    falutBarUFA.map((val, i) => {
                                                        if (i >= 4) {
                                                            return (
                                                                <div className="row" key={i - 4}>
                                                                    <span className="label">{val.key.ECU}</span>
                                                                    <div className="bar-wrap_bus">
                                                                        <div className="bar_bus" data-value={val.UniqueSignal.value} style={{ width: faultAnaPercent[i] + "%" }} />
                                                                    </div>
                                                                    <span className="number">{val.UniqueSignal.value}</span>
                                                                </div>)
                                                        }
                                                    })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className="v-title chartbox">
                        <div className="titlebg_bus text-fit">Fault Duration Analysis</div>
                        <div className="row" >
                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">Mins</p>
                                        </div>
                                    </div>

                                    <div className="chart-wrap_bus">
                                        <WaterMark />
                                        <div id="dashboard-stats" className="chart bars-horizontal brand-primary">
                                            {
                                                falutBarNew.map((val, i) => {
                                                    if (i <= 3) {
                                                        return (<div className="row" key={i}>
                                                            <span className="label">{val.name}</span>
                                                            <div className="bar-wrap_bus">
                                                                <div className="bar_bus" data-value={val.rating.value} style={{ width: faultNewPercent[i] + "%" }} />
                                                            </div>
                                                            <span className="number">{val.rating.toFixed(0)}</span>
                                                        </div>)
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">Mins</p>
                                        </div>
                                    </div>

                                    <div className="chart-wrap_bus">
                                        <WaterMark />
                                        <div id="dashboard-stats" className="chart bars-horizontal brand-primary">
                                            {
                                                falutBarNew.map((val, i) => {
                                                    if (i >= 4) {
                                                        return (
                                                            <div className="row" key={i}>
                                                                <span className="label">{val.name}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.rating.value} style={{ width: faultNewPercent[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.rating.toFixed(0)}</span>
                                                            </div>)
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-12">
                    <div className="v-title chartbox">
                        <div className="titlebg_bus text-fit">Alarm Distinct Signals</div>
                        <div className="row" >
                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">Distinct Signals</p>
                                        </div>
                                    </div>
                                    <div className="chart-wrap_bus">
                                        <WaterMark />
                                        <div id="dashboard-statsUAA" className="chart bars-horizontal brand-primary">
                                            {
                                                falutBarUAA.map((val, i) => {
                                                    if (i <= 3) {
                                                        return (
                                                            <div className="row" key={i}>
                                                                <span className="label">{val.key.ECU}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.UniqueSignal.value} style={{ width: UAAPercent[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.UniqueSignal.value}</span>
                                                            </div>)
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-12 pr-2">
                                <div className="chartHGT">
                                    <div className="boxHead_bus">
                                        <div className="float-start">
                                            <p className=" boxHeadText">ECU</p>
                                        </div>
                                        <div className="float-end">
                                            <p className="boxHeadText">Distinct Signals</p>
                                        </div>
                                    </div>
                                    <div className="chart-wrap_bus">
                                        <WaterMark />
                                        <div id="dashboard-statsUAA" className="chart bars-horizontal brand-primary">
                                            {
                                                falutBarUAA.map((val, i) => {
                                                    if (i >= 4) {
                                                        return (
                                                            <div className="row" key={i}>
                                                                <span className="label">{val.key.ECU}</span>
                                                                <div className="bar-wrap_bus">
                                                                    <div className="bar_bus" data-value={val.UniqueSignal.value} style={{ width: UAAPercent[i] + "%" }} />
                                                                </div>
                                                                <span className="number">{val.UniqueSignal.value}</span>
                                                            </div>)
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}



